import { makeStyles } from '@material-ui/core/styles';

import type { CustomTheme, Colors } from 'theme';

import type { Steps, StepComponentProps } from './Stepper';

const useStyles = makeStyles((theme: CustomTheme) => ({
  flexContainer: {
    display: 'flex',
  },
  gridContainer: {
    flexGrow: 1,
    display: 'grid',
    gridTemplateColumns: 'repeat(12, 1fr)',
  },
  stepper: {
    justifyContent: 'center',
    [theme.breakpoints.down('xl')]: {
      gridColumnStart: 3,
      gridColumnEnd: 11,
    },
    [theme.breakpoints.down('sm')]: {
      gridColumnStart: 2,
      gridColumnEnd: 12,
    },
    [theme.breakpoints.down('xs')]: {
      gridColumnStart: 1,
      gridColumnEnd: 12,
    },
  },
  stepIconRoot: {
    '&.MuiStepIcon-completed': {
      color: theme.palette.success.main,
    },
  },
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-end',
    [theme.breakpoints.down('xl')]: {
      gridColumnStart: 11,
      gridColumnEnd: 'span 2',
      marginRight: theme.spacing(6),
    },
    [theme.breakpoints.down('sm')]: {
      gridColumnStart: 12,
      marginRight: theme.spacing(1),
    },
  },
  button: {
    maxWidth: theme.spacing(17),
    [theme.breakpoints.down('xl')]: {
      width: '100%',
    },
    [theme.breakpoints.down('sm')]: {
      width: 'auto',
    },
  },
  linearProgressContainer: {
    gridColumnEnd: 'span 12',
    height: theme.spacing(1),
    backgroundColor: theme.palette.primary.light,
  },
  linearProgressBar: {
    borderRadius: '5px',
    backgroundColor:
      theme.custom && (theme.custom.colors as Colors).stepperBarFill,
  },
  hiddenStep: {
    display: 'none',
  },
}));

export const useConnectorStyles = makeStyles((theme) => ({
  stepConnector: (steps: Steps<StepComponentProps>) => {
    const styles: Record<string, number | string | Record<string, string>> = {
      visibility: 'hidden',
      maxWidth: theme.spacing(8),
    };
    steps.forEach(({ hidden }, index) => {
      if (hidden && index < steps.length - 1) {
        styles[`&:nth-child(${2 * index + 2})`] = { display: 'none' };
      }
    });
    return styles;
  },
}));

export default useStyles;
